import { Controller } from "@hotwired/stimulus";

/**
 * トークルームのメッセージ送信ボタンの動作を管理する
 *   - テキストエリアに入力が無い場合は送信ボタンを非活性にする
 *   - メッセージの改行に応じてテキストエリアの高さを可変する
 *   - メッセージ送信後にテキストエリアをクリアし、送信ボタンを非活性にする
 *
 * 設定例
 * <%= form_with data: {
 *       controller: "talkroom-send-button",
 *       action: "submit->talkroom-send-button#submitAndClearTextarea"
 *       } do |f| %>
 *   <%= f.textarea data: {
 *         talkroom_send_button_target: "textarea",
 *         action: %w[
 *           input->talkroom-send-button#enableSendButton
 *           input->talkroom-send-button#textareaAutoResize
 *         ].join(" ") } %>
 *   <%= image_submit_tag "", data: { talkroom_send_button_target: "sendButton" } %>
 * <%= end %>
 */
export default class extends Controller {
  static targets = ["textarea", "sendButton", "uploadButton"];

  connect() {
    this.enableSendButton();
    // 初期値がある場合にテキストエリアの高さを調整
    this.textareaAutoResize();
  }

  /**
   * チャットメッセージが入力されている場合に送信ボタンを有効にする
   */
  enableSendButton() {
    const sendMessageIcon = require("../../images/send-message.svg");
    const disableSendMessageIcon = require("../../images/disable-send-message.svg");

    if (this.textareaTarget.value) {
      this.sendButtonTarget.src = sendMessageIcon;
      this.sendButtonTarget.disabled = false;
    } else {
      this.sendButtonTarget.src = disableSendMessageIcon;
      this.sendButtonTarget.disabled = true;
    }
  }

  /**
   * テキストエリアの改行状態に応じて高さを可変する
   */
  textareaAutoResize() {
    this.textareaTarget.style.height = "auto";
    this.textareaTarget.style.height = this.textareaTarget.scrollHeight + "px";
  }

  /**
   * メッセージ送信とテキストエリアの消去
   */
  submitAndClearTextarea(event) {
    event.preventDefault();

    if (!this.textareaTarget.value) {
      // メッセージが入力されていない場合は送信しない
      alert("メッセージを入力してください");
      return;
    }

    const formData = new FormData(event.target);

    // 重複送信しないように送信ボタンを非活性にする
    this.sendButtonTarget.disabled = true;
    this.uploadButtonTarget.disabled = true;

    fetch(event.target.action, {
      method: "POST",
      body: formData,
      redirect: "error",
    })
      .then((response) => {
        if (!response.ok) {
          // 422 (ルームがアクティブでない場合) など。
          console.error("メッセージ送信エラー (" + response.status + ")");
          return Promise.reject();
        }

        // メッセージ送信成功後、テキストエリアをリセットする
        this.textareaTarget.value = null;
        this.textareaAutoResize();

        this.enableSendButton();
        this.uploadButtonTarget.disabled = false;
      })
      .catch((error) => {
        if (error) {
          console.error(error);
        }
        // 422 (ルームがアクティブでない場合) やリダイレクト（ログアウト状態）やネットワークエラーなど。
        // もしかするとメッセージ作成できている場合もあるかもしれないので「送信に失敗しました」ではなくて汎用的なエラーメッセージを表示
        alert("エラーが発生しました");
        location.reload();
      });
  }
}
